// Externals
import React from 'react';

// Styles
import './QuestionText.scss';

/*::
	type Props = {
		children: Array<React.Component>
	}
*/
// ProgressBone component
const QuestionText = (props /*: Props */) /*: React.Component */ => {
	return (
		<div className="question-text">
			<label  data-cy="question-text">
				{props.children}
			</label>
			{props.description && <p className='description-text'>{props.description}</p>}
		</div>
	);
};

// Exports
export default QuestionText;
